<!-- TwilioChatPreview.vue -->
<template>
  <v-list class="chat-list pa-0">
    <v-list-item-group v-model="selectedChat">
      <v-list-item
        v-for="chat in chats"
        :key="chat.id"
        @click="handleChatSelect(chat)"
        :class="{ 'unread': chat.unread }"
      >
        <!-- Avatar del contacto -->
        <v-list-item-avatar>
          <v-avatar color="grey" size="40">
            <v-img
              v-if="chat.avatar"
              :src="chat.avatar"
              :alt="chat.name"
            ></v-img>
            <span v-else class="white--text text-h6">
              {{ getInitials(chat.name) }}
            </span>
          </v-avatar>
        </v-list-item-avatar>

        <!-- Información del chat -->
        <v-list-item-content>
          <v-list-item-title class="d-flex justify-space-between">
            <span :class="{ 'font-weight-bold': chat.unread }">
              {{ chat.name }}
            </span>
            <span class="caption grey--text">
              {{ chat.lastMessageTime }}
            </span>
          </v-list-item-title>

          <v-list-item-subtitle class="d-flex align-center">
            <!-- Icono de estado del mensaje -->
            <v-icon
              v-if="chat.status"
              size="16"
              class="mr-1"
              :color="getStatusColor(chat.status)"
            >
              {{ getStatusIcon(chat.status) }}
            </v-icon>

            <!-- Último mensaje -->
            <span :class="{ 'font-weight-medium': chat.unread }">
              {{ chat.lastMessage }}
            </span>

            <!-- Badge para mensajes no leídos -->
            <v-badge
              v-if="chat.unreadCount"
              :content="chat.unreadCount"
              color="primary"
              class="ml-auto"
            ></v-badge>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: 'TwilioChatPreview',

  data: () => ({
    selectedChat: null,
    chats: [
      {
        id: 1,
        name: 'Juan Pérez',
        avatar: null,
        lastMessage: '¿Podemos agendar una llamada?',
        lastMessageTime: '10:30',
        unread: true,
        unreadCount: 3,
        status: 'sent'
      },
      {
        id: 2,
        name: 'María García',
        avatar: '/path-to-avatar.jpg',
        lastMessage: 'Gracias por la información',
        lastMessageTime: '9:15',
        unread: false,
        unreadCount: 0,
        status: 'read'
      },
      // Agregar más chats aquí
    ]
  }),

  methods: {
    getInitials(name) {
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
    },

    getStatusIcon(status) {
      const icons = {
        sent: 'mdi-check',
        delivered: 'mdi-check-all',
        read: 'mdi-check-all'
      }
      return icons[status]
    },

    getStatusColor(status) {
      return status === 'read' ? 'primary' : 'grey'
    },

    handleChatSelect(chat) {
      this.$emit('chat-selected', chat)
    }
  }
}
</script>

<style scoped>
.chat-list {
  height: calc(100vh - 120px); /* Ajusta según el tamaño de tu header y filtros */
  overflow-y: auto;
}

.v-list-item {
  border-bottom: 1px solid #f0f0f0;
}

.unread {
  background-color: #f8f9fa;
}
</style>
